import { routes } from './routes';

export const sections = {
  PERSONAL: 'personal_data',
  JOBS: 'jobs',
  INVESTMENTS: 'investments',
  DEDUCTIONS: 'deductions',
  RESULT: 'result',
  FILING: 'filing',
};

export const navLinks = [
  {
    sectionId: sections.PERSONAL,
    label: 'Links.personalData',
    route: routes.PERSONAL_START,
    icon: 'IconUserSpaceM',
  },

  {
    sectionId: sections.JOBS,
    label: 'Links.work',
    route: routes.JOBS_START,
    icon: 'IconBriefcaseM',
  },
  {
    sectionId: sections.INVESTMENTS,
    label: 'Links.investments',
    route: routes.INVESTMENTS_START,
    icon: 'IconGraphsM',
  },
  {
    sectionId: sections.DEDUCTIONS,
    label: 'Links.othersIncomes',
    route: routes.DEDUCTIONS_START,
    icon: 'IconPercentageM',
  },
  {
    sectionId: sections.RESULT,
    label: 'Links.result',
    route: routes.RESULT,
    icon: 'IconOutputM',
  },
  {
    sectionId: sections.FILING,
    label: 'Links.filing',
    route: routes.FILING,
    icon: 'IconVerifiedDocumentM',
  },
];
